import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { Subscription } from 'rxjs';
import { CmsCore } from 'store/cms/models';

@Component({
    selector: 'xm-checkbox',
    styleUrls: ['./checkbox.scss'],
    templateUrl: './checkbox.html',
    standalone: false
})
export class XmCheckboxComponent implements OnInit, OnDestroy {
    @Input() public isSelected: boolean;
    @Input() public isXMCCardSelected: boolean;
    @Input() public isSmall: boolean;
    @Input() public isError: boolean;

    public backgroundImage: MediaImageOptions;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (cmsCore: CmsCore) => {
            this.backgroundImage = {
                mobile: Cloudinary.generateMediaFromCms(cmsCore.icons.checkBox)
            };
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
